import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { Loader2 } from "lucide-react";
import { trpc } from "@/hooks/trpc";
import { toast } from "sonner";
import { AnalysisSection } from "@/features/food-sessions/analysis-section";
import { FoodSessionId, FoodSessionStatusEnum } from "@brewbase/db/types";

export const Route = createFileRoute("/food-app/sessions/$session_id/analysis")({
  component: AnalysisPage,
});

function AnalysisPage() {
  const { session_id } = Route.useParams();
  const navigate = useNavigate();
  const utils = trpc.useUtils();

  const { data: session, isLoading } = trpc.food.sessions.get.useQuery(session_id as FoodSessionId);

  const updateMutation = trpc.food.sessions.update.useMutation({
    onSuccess: async () => {
      await utils.food.sessions.get.invalidate(session_id);
      utils.food.sessions.list.invalidate();
      utils.food.sessions.listRecent.invalidate();
      navigate({
        to: "/food-app/sessions/$session_id/results",
        params: { session_id: session_id as FoodSessionId },
      });
    },
    onError: (err) => toast.error(`Failed to update session: ${err.message}`),
  });

  if (isLoading || !session) {
    return (
      <div className="flex items-center justify-center h-full">
        <Loader2 className="h-4 w-4 animate-spin text-muted-foreground" />
      </div>
    );
  }

  function handleComplete() {
    updateMutation.mutate({ id: session_id as FoodSessionId, status: FoodSessionStatusEnum.completed });
  }

  return <AnalysisSection session={session} onComplete={handleComplete} />;
}
